module.exports = __webpack_public_path__ + "static/media/only-me-settings-icon.bba6f905.svg";